import React from 'react';
import { Box, LoadingSpinner } from '@sparknz/spark-pattern-library';

const FallbackLoadingSpinner = () => {
  return (
    <Box pt="s4">
      <LoadingSpinner size={40} />
    </Box>
  );
};

export default FallbackLoadingSpinner;
